import * as React from "react";
import Input from "../Input/Input";
import PickADay from "./PickADay";
import type { Locale } from "./text.i18n";
import styles from "./PickADayInput.module.css";
import { view } from "@orderofchaos/mvvm";
import { PickADayInputViewModel } from "./PickADayInputViewModel";

export interface PickADayInputProps {
  value: string;
  onChangeValue: (value: string) => void;
  locale?: Locale;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  flip?: boolean;
}

export const PickADayInput: React.FC<PickADayInputProps> = view(
  PickADayInputViewModel,
)<PickADayInputProps>(({
  viewModel: {
    rootClassName,
    value,
    placeholder,
    disabled,
    isOpen,
    locale,
    flip,
    pickerDate,
    setRootElement,
    openPicker,
    closePicker,
    togglePicker,
    onDatePicked,
  },
}) => {
  return (
    <div className={rootClassName} ref={setRootElement}>
      <Input
        value={value}
        placeholder={placeholder}
        readOnly
        disabled={disabled}
        onClick={openPicker}
        onIconClick={togglePicker}
        iconName="Clock"
      />
      {isOpen ? (
        <>
          <button
            type="button"
            aria-label="Закрыть календарь"
            className={styles.PickADayInput__backdrop}
            onClick={closePicker}
          />
          <div className={styles.PickADayInput__panel}>
            <PickADay
              date={pickerDate}
              onChangeDate={onDatePicked}
              locale={locale}
              flip={flip}
            />
          </div>
        </>
      ) : null}
    </div>
  );
});
